import { Routes } from '@angular/router';
import { AuthComponent } from './auth.component';
import { AuthLoginAutoComponent } from './components/auth-login-auto/auth-login-auto.component';
import { AuthLoginComponent } from './components/auth-login/auth-login.component';
import { AuthLogoutComponent } from './components/auth-logout/auth-logout.component';
import { AuthRequestComponent } from './components/auth-request/auth-request.component';
import { AuthRestoreComponent } from './components/auth-restore/auth-restore.component';
import { TwoFactorAuthComponent } from './components/two-factor-auth/two-factor-auth.component';
import { AuthLogin2FAComponent } from './components/auth-login-2FA/auth-login-2FA.component';
export const ROUTES: Routes = [
  {
    path: 'auth',
    component: AuthComponent,
    children: [
      {
        path: 'login',
        component: AuthLoginComponent,
      },
      {
        path: 'login2FA',
        component: AuthLogin2FAComponent,
      },
      {
        path: 'login-auto/:userId/:psw',
        component: AuthLoginAutoComponent,
      },
      {
        path: 'login-auto/:userId/:psw/:menu',
        component: AuthLoginAutoComponent,
      },
      {
        path: 'logout',
        component: AuthLogoutComponent,
      },
      {
        path: 'request-password',
        component: AuthRequestComponent,
      },
      {
        path: 'restore-password',
        component: AuthRestoreComponent,
      },
    ],
  },
];

export const ROUTESTWOFACTOR: Routes = [
  {
    path: 'two-factor-auth/:guid',
    component: TwoFactorAuthComponent,
  },
];
